// Copyright (c) Microsoft. All rights reserved.

import { makeStyles } from '@fluentui/react-components';
import React from 'react';
import { IChatMessage } from '../../../libs/models/ChatMessage';
import { convertToAnchorTags } from '../../utils/TextUtils';
import * as utils from './../../utils/TextUtils';

const useClasses = makeStyles({
    content: {
        wordBreak: 'break-word',
    },
});

interface ChatHistoryLinkTextContentProps {
    message: IChatMessage;
}

export const ChatHistoryLinkTextContent: React.FC<ChatHistoryLinkTextContentProps> = ({ message }) => {
    const classes = useClasses();

    let content = message.content.trim();
    content = utils.formatChatTextContent(message);
    content = content.replace(/\n/g, '<br />').replace(/ {2}/g, '&nbsp;&nbsp;');

    return <div className={classes.content} dangerouslySetInnerHTML={{ __html: convertToAnchorTags(content) }} />;
};
